/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Avatar, Grid, Tooltip } from '@mui/material';
import _ from 'lodash';
import './EmployeeTeam.css';
interface Props {
  teamMembers: any;
}

const EmployeeTeam = ({ teamMembers }: Props) => {
  const [showMsg, setShowMsg] = useState(false);
  const [name, setName] = useState<any>();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Tooltip
          title={name}
          open={showMsg}
          placement="bottom-start"
          PopperProps={{
            sx: { top: '100px' },
          }}
        >
          <div className="x__scrollbar">
            {_.map(teamMembers, (teamMate: any) => {
              return (
                <div>
                  <Avatar
                    src={teamMate?.profile_pic}
                    style={{
                      width: '60px',
                      height: '60px',
                      marginLeft: '10px',
                    }}
                    onMouseEnter={() => {
                      setShowMsg(true);
                      setName(`${teamMate?.first_name} ${teamMate?.last_name}`);
                    }}
                    onMouseLeave={() => {
                      setShowMsg(false);
                      setName('');
                    }}
                  />
                </div>
              );
            })}
          </div>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default EmployeeTeam;
